// src/components/header/CTA.jsx
import { useState } from "react";
import PdfViewer from "../pdfViewer/PdfViewer";
import CV from "../../assets/mahdi_chihi_cv.pdf";
import { AnimatePresence, motion } from "framer-motion";
import { fadeUp } from "../../animations";
import useWindowWidth from "../../hooks/useWindowWidth";
import { FiX } from "react-icons/fi";
import { RxExternalLink } from "react-icons/rx";
import { LiaDownloadSolid } from "react-icons/lia";
import "./Header.css";

const CTA = () => {
  const [showPdf, setShowPdf] = useState(false);
  const width = useWindowWidth();

  const customWidth = Math.min(width - 68, 800);

  return (
    <div className="cta">
      <motion.div className="cta" variants={fadeUp}>
        <button className="btn" onClick={() => setShowPdf(true)}>
          See my CV
        </button>

        <a href="#contact" className="btn btn-primary">
          Let's Talk
        </a>
      </motion.div>

      <AnimatePresence>
        {showPdf && (
          <motion.div
            onClick={() => setShowPdf(false)}
            className="pdf-overlay"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={{
              hidden: { opacity: 0, scale: 0.95 },
              visible: {
                opacity: 1,
                scale: 1,
                transition: { duration: 0.2, ease: "easeOut" },
              },
            }}
          >
            {/* Top actions */}
            <div className="pdf-actions">
              <button className="icon-btn" onClick={() => setShowPdf(false)}>
                <FiX size={22} />
              </button>

              <a href={CV} download="Mahdi_Chihi_CV.pdf" className="icon-btn">
                <LiaDownloadSolid size={22} />
              </a>

              <a href={CV} target="_blank" rel="noreferrer" className="icon-btn">
                <RxExternalLink size={22} />
              </a>
            </div>

            {/* PDF container */}
            <div
              className="pdf-modal"
              onClick={(e) => e.stopPropagation()}
              style={{ width: customWidth }}
            >
              <PdfViewer fileUrl={CV} />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CTA;
